
import _ from 'lodash'
import ProdFilterSectionCategoryTree from './ProdFilterSectionCategoryTree.vue'
import { isSelectedCategory } from '@/feature/search/utils'

export default {
  name: 'ProdFilterSection',
  components: {
    ProdFilterSectionCategoryTree,
  },
  filters: {
    number: value => isNaN(value) ? value : Intl.NumberFormat().format(value),
    count: value => _.isObject(value) ? value.count : value,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    categoryData: {
      type: Object,
      default: () => undefined,
    },
    propertyData: {
      type: Array,
      default: () => undefined,
    },
    filterCheck: {
      type: Array,
      default: function () {
        return []
      }
    },
    limit: {
      type: Number,
      default: 0
    },
  },
  emits: ['update-filter-check', 'show-all'],
  setup (_props, { emit }) {
    const handleUpdate = value => emit('update-filter-check', value)
    const handleShowAll = () => emit('show-all')
    return {
      handleUpdate,
      handleShowAll,
    }
  },
  data () {
    return {
      isSelectedSmallCategory: false,
      itemMoreLimit: {
        unfoldingList: [],
        size: 6,
      },
      isChecked: false
    }
  },
  computed: {
    localFilterCheck: {
      get: function () {
        if (this.filterCheck !== null) {
          const newArr = this.list.filter(item => this.filterCheck.some(check => check.type === item.type && check.id === item.id)).concat(this.filterCheck).filter((item, idx, self) =>
            idx === self.findIndex(t => (
              t.id === item.id && t.name === item.name && t.type === item.type && t.value === item.value
            ))
          )
          return newArr
        } else {
          return this.filterCheck
        }
      },
      set: function (value) {
        this.handleUpdate(
          isSelectedCategory(_.last(value))
            ? [_.last(value)] // 카테고리 선택시 카테고리만으로
            : value
        )
      },
    }
  },
  mounted () {
  },
  methods: {
    toggleFolding (index) {
      this.itemMoreLimit.unfoldingList =
        this.isUnfold(this.itemMoreLimit.unfoldingList, index)
          ? _.filter(this.itemMoreLimit.unfoldingList, item => item !== index)
          : _.concat(this.itemMoreLimit.unfoldingList, index)
    },
    isUnfold: (list, index) => _.includes(list, index),
    handleChangedCategory (value) {
      this.localFilterCheck = _(this.localFilterCheck)
        .filter(item => !item.onlyOne)
        .push(value)
        .value()
    },
    handleChangedProperty (values) {
      this.localFilterCheck = _(this.localFilterCheck)
        .filter(fc => fc.type !== 'attrItemCd')
        .concat(values)
        .value()
    },
    isCheckedState (item) { // 상품상세 진입 후 결과 페이지로 복귀 시 체크박스 체크 유지
      if (this.isChecked) {
        this.isChecked = false
        console.log('체크 풀림!')
      } else {
        this.isChecked = true
        console.log('체크 됨!')
        return this.localFilterCheck.some(check => check.type === item.type && check.id === item.id)
      }
    }
  },
}
